import { jsx } from 'react/jsx-runtime';
import { styled } from '@flex-design-system/stitches-react';
import { clsx } from '@flex-design-system/ve-presets';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { forwardRef } from 'react';
import { Typography } from '../typography/Typography.mjs';
import { TabsContent } from './components/content/Content.mjs';
import { TabsItem } from './components/item/Item.mjs';
import { TabsItemSlot } from './components/item/ItemSlot.mjs';
import { TabsList } from './components/list/List.mjs';
import { tabs } from './tabs.vanilla.mjs';

const TabsImpl = forwardRef(
  ({ activationMode = "manual", className: classNameFromProps, ...props }, forwardedRef) => {
    const className = clsx(tabs, classNameFromProps);
    return /* @__PURE__ */ jsx(
      StyledTabsRoot,
      {
        "data-scope": "tabs",
        "data-part": "root",
        activationMode,
        className,
        orientation: "horizontal",
        ref: forwardedRef,
        ...props
      }
    );
  }
);
const StyledTabsRoot = styled(TabsPrimitive.Root);
const Tabs = Object.assign({}, TabsImpl, {
  List: styled(TabsList),
  Item: styled(TabsItem),
  /** @deprecated `Tabs.ItemSlot`을 사용해 주세요. */
  ItemLeftSlot: TabsItemSlot,
  /** @deprecated `Tabs.ItemSlot`을 사용해 주세요. */
  ItemRightSlot: TabsItemSlot,
  ItemSlot: TabsItemSlot,
  Content: TabsContent,
  /** @deprecated `Tabs.Item`을 사용해 주세요. */
  Legacy_Trigger: styled(TabsItem),
  /** @deprecated `Tabs.ItemSlot`을 사용해 주세요. */
  Legacy_TriggerLeftSlotRoot: TabsItemSlot,
  /** @deprecated `Tabs.ItemSlot`을 사용해 주세요. */
  Legacy_TriggerRightSlotRoot: TabsItemSlot,
  /** @deprecated `Tabs.Item`으로 교체 후, 제거해 주세요. */
  Legacy_Label: styled(Typography)
});
Tabs.displayName = "Tabs";

export { Tabs };
//# sourceMappingURL=Tabs.mjs.map
